export default __webpack_public_path__ + "static/media/arw-1.c3929a63.svg";